import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Models
import { ICounsellor, ICounsellorsFilters, ICounsellorsResponse } from '../../interfaces/counsellors.interfaces';

export interface ICounsellorsState {
  counsellors: ICounsellor[],
  filters: ICounsellorsFilters,
  total: number;
  total_all: number;
  loading: boolean;
  error: string | null;
}

const initialState: ICounsellorsState = {
  counsellors: [],
  filters: {
    offset: 0,
    limit: 10,
  },
  total: 0,
  total_all: 0,
  loading: true,
  error: null
};

export const counsellorsSlice = createSlice({
  name: 'counsellors',
  initialState,
  reducers: {
    loadCounsellorsRequest(state, { payload: { isFirstLoad } }: PayloadAction<{ isFirstLoad: boolean }>) {
      state.loading = true;
      state.error = null;
    },
    loadCounsellorsRequestSuccess: (state, { payload }: PayloadAction<ICounsellorsResponse>) => {
      state.counsellors = payload.experts ?? [];
      state.total = payload.total ?? 0;
      state.total_all = payload.total_all ?? 0;
      state.loading = false;
      state.error = null;
    },
    loadCounsellorsRequestFailure: (state, { payload: error }: PayloadAction<string>) => {
      state.loading = false;
      state.error = error;
    },
    setFilters(state, { payload }: PayloadAction<ICounsellorsFilters>) {
      state.filters = payload;
    },
    updateCounsellorInfo: (state, { payload }: PayloadAction<ICounsellor>) => {
      state.counsellors = state.counsellors.map(counsellor => {
        if (counsellor.id === payload.id) {
          return { ...payload };
        }
        return counsellor;
      })
    },
    clearCounsellors: (state) => {
      state.counsellors = [];

      // TODO maybe not clear
      state.filters = {};

      state.loading = true;
      state.error = null;
    }
  }
});

export const CounsellorsSliceActions = counsellorsSlice.actions;
